import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=bc1bb908&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=bc1bb908&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1bb908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc1bb908')) {
      api.createRecord('bc1bb908', component.options)
    } else {
      api.reload('bc1bb908', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=bc1bb908&scoped=true", function () {
      api.rerender('bc1bb908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/privacy/en_US/privacy.vue"
export default component.exports